module.exports = __webpack_public_path__ + "img/chain-gang-all-stars.e314792e.png";